"use client";
import * as React from "react";
import { motion } from "framer-motion";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

const springTransition = {
  type: "spring",
  dampingRatio: 0.6,
  stiffness: 100,
};

export const AnimatedLogo = (props: { className?: string }) => {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Ensure component is mounted before using theme to prevent hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  // Use a safe fallback during SSR and initial hydration
  const fillColor = mounted && theme === "light" ? "#000" : "#fff";

  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="svg1"
      version="1.1"
      viewBox="0 0 237.313 250"
    >
      <defs id="defs1">
        <clipPath id="clipPath16" clipPathUnits="userSpaceOnUse">
          <motion.path
            initial={{ d: "M358.548 262.249h0v250h0z" }}
            animate={{ d: "M358.548 262.249h125v250h-125z" }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            id="rect16"
            fill="red"
            strokeWidth="0.264"
          ></motion.path>
        </clipPath>
        <clipPath id="clipPath18" clipPathUnits="userSpaceOnUse">
          <motion.path
            initial={{ d: "M516.035 634.892h0v283.217h0z" }}
            animate={{ d: "M516.035 634.892h169.619v283.217H516.035z" }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            id="rect18"
            fill="red"
            strokeWidth="0.332"
          ></motion.path>
        </clipPath>
      </defs>
      <g id="layer2" transform="translate(-209.123 -263.392)">
        <path
          id="rect1"
          fill="transparent"
          strokeWidth="0.067"
          d="M200.485 259.262h253.549v261.793H200.485z"
        ></path>
      </g>
      <g id="layer1" transform="translate(-209.123 -263.392)">
        <g
          id="g12-3"
          fill={fillColor}
          clipPath="url(#clipPath18)"
          transform="matrix(.88714 0 0 .88714 -252.1 -300.597)"
        >
          <g
            id="SvgjsG5263-2"
            transform="matrix(.35667 0 0 .35667 495.11 598.25)"
          >
            <g id="g10-4">
              <path
                id="path1-2"
                d="M605.5 333.8c-36.8-64.1-73.4-128.2-110.9-191.8-3-5-12.3-8.7-18.7-8.9-34-.7-68.1-.7-102.1-.3-9-16.5-26.6-27.7-46.7-27.7-29.3 0-53.1 23.8-53.1 53.1s23.8 53.1 53.1 53.1c19.9 0 37.3-11 46.4-27.3 24.2 0 47.8 0 71.4.3 6.4.1 15.6 1.2 18.6 5.4 9.9 13.8 17.5 29.2 27.9 47.2h-25.2c-55.8 0-111.6-.2-167.4.3-7.1.1-17.3.9-20.7 5.4-9.7 13.1-16.6 28.2-26.4 45.8h24c68.4 0 136.8 1.6 205.1-.8 30.2-1 50.2 6 61.3 35.3 2.6 6.9 11.2 14.9 18.2 16.1 14.7 2.5 30.1.8 45.1.8.1-3.4.7-5.1.1-6M346.3 183.9c-5.4 4-12.1 6.4-19.3 6.4-17.8 0-32.2-14.5-32.2-32.2 0-17.8 14.5-32.2 32.2-32.2 8.1 0 15.5 3 21.1 7.9 6.8 5.9 11.1 14.6 11.1 24.3.1 10.5-5 19.9-12.9 25.8"
              ></path>
              <path id="path2-7" d="M681.5 173.5"></path>
              <path
                id="path3-2"
                d="M689.3 812.4c-.5.9-1 1.7-1.6 2.6-1.6-1.1-3.4-2-5.2-2.8 2.3.1 4.5.1 6.8.2"
              ></path>
              <path
                id="path4-5"
                d="M428.3 794.6c-31.6-60.6-61.9-122-95.6-181.5-14.9-26.3-17.9-47.3 2.9-70.6 4.9-5.5 8-16.9 5.8-23.5-4.6-14.2-13.2-27-20.2-40.3-2.9 1.3-4.6 1.6-5.2 2.5-39.8 62.2-79.7 124.4-118.7 187.1-3.1 5-2.1 15 .8 20.7 15.1 30.4 30.8 60.5 46.8 90.5-6.3 8.7-10 19.4-10 31 0 29.3 23.8 53.1 53.1 53.1s53.1-23.8 53.1-53.1c0-28.2-22.1-51.4-50-53-11.4-21.9-22.5-43.2-33.4-64.7-2.9-5.7-6.1-14.4-3.8-19 7.6-15.1 17.8-29 28.9-46.5 5.3 10.2 8.5 16.2 11.7 22.3 25.8 49.5 51.5 99 77.7 148.3 3.3 6.3 8.8 15 14.3 15.8 16.1 2.5 32.7 1.7 52.8 2.2-4.7-9.3-7.8-15.3-11-21.3m-123.9-12s.1 0 0 0c9.5 5.6 15.9 16 15.9 27.8 0 17.8-14.5 32.2-32.2 32.2s-32.2-14.5-32.2-32.2c0-3.3.5-6.4 1.4-9.4 4-13.2 16.3-22.8 30.8-22.8 6 0 11.6 1.6 16.3 4.4"
              ></path>
              <path
                id="path5-5"
                d="M877.4 470.3c-29.3 0-53.1 23.8-53.1 53.1 0 11.3 3.5 21.8 9.6 30.4-10.4 17.2-20.7 34-31.1 50.7-3.4 5.4-9.2 12.7-14.3 13.1-16.9 1.3-34-.2-54.8-.6 5.9-9.8 9.5-15.7 13.1-21.5 28.9-47.7 58-95.4 86.6-143.3 3.6-6.1 8.2-15.3 6.1-20.5-6.2-15.1-15.5-28.8-25.5-46.3-5.5 9-9 14.8-12.4 20.5-35.4 58.5-72.3 116.2-105.7 175.8-14.7 26.3-31.1 39.8-61.9 34.1-7.3-1.3-18.6 1.9-23.2 7.2-9.7 11.3-16.2 25.3-24 38.2 2.6 1.8 3.7 3.2 4.8 3.2 73.8 1.8 147.7 3.7 221.5 4.6 5.8.1 13.9-6 17.3-11.4 17-26.7 33.4-53.8 49.6-81 28-1.4 50.4-24.6 50.4-53 .1-29.5-23.7-53.3-53-53.3m17.7 80c-5.1 3.4-11.1 5.3-17.7 5.3-14.5 0-26.7-9.6-30.8-22.7-.9-3-1.4-6.2-1.4-9.5 0-15.7 11.3-28.9 26.3-31.7.2-.3.4-.7.7-1.1.2.3.3.6.5.9 1.6-.2 3.2-.4 4.8-.4 17.8 0 32.2 14.5 32.2 32.2-.1 11.4-5.9 21.3-14.6 27"
              ></path>
              <path
                id="path6-7"
                d="M682.5 812.2c1.8.8 3.6 1.7 5.2 2.8.5-.8 1-1.7 1.6-2.6-2.3-.1-4.5-.1-6.8-.2"
              ></path>
              <path
                id="path7-0"
                d="M728.6 709.3c-68.3-2.2-136.7-6-205-5.8-30.2.1-50-7.6-60.1-37.2-2.4-7-10.8-15.3-17.7-16.6-14.6-2.9-30-1.7-45.1-2.2-.3 3.2-.9 4.8-.4 5.8C435 718.5 469.6 783.8 505 848.6c2.8 5.1 12 9.1 18.4 9.5 32.4 1.7 64.8 2.7 97.2 3.5 7.8 19.6 27 33.6 49.4 33.6 29.3 0 53.1-23.8 53.1-53.1S699.3 789 670 789c-17.5 0-33.1 8.5-42.7 21.6-24.2-.8-47.8-1.6-71.3-2.6-6.4-.3-15.6-1.7-18.4-6-9.4-14.1-16.6-29.7-26.3-48.1 11.5.4 18.3.6 25.2.8 55.8 1.8 111.6 3.7 167.4 5.1 7.1.2 17.4-.3 20.8-4.7 10.1-12.8 17.5-27.7 27.9-44.9-10.5-.4-17.3-.6-24-.9m-68.9 102.2c3.3-1.1 6.8-1.8 10.5-1.8 4.4 0 8.5.9 12.4 2.5 2.3.1 4.5.1 6.8.2-.5.9-1 1.7-1.6 2.6 8.8 5.8 14.6 15.7 14.6 27 0 17.8-14.5 32.2-32.2 32.2-10.2 0-19.3-4.8-25.2-12.2-4.4-5.5-7-12.4-7-20-.1-14.2 9-26.2 21.7-30.5"
              ></path>
              <path
                id="path8-5"
                d="M424.8 323.3c-73.7-4.1-147.5-8.4-221.3-11.6-5.8-.3-14 5.5-17.7 10.9-19.3 28.4-38 57.2-56.4 86.1-2.2-.3-4.5-.4-6.8-.4-29.3 0-53.1 23.8-53.1 53.1s23.8 53.1 53.1 53.1 53.1-23.8 53.1-53.1c0-8-1.8-15.6-5-22.4 13.9-21.3 27.4-42 41-62.5 3.5-5.3 9.6-12.4 14.7-12.7 16.9-.8 34 1.2 54.7 2.4-6.3 9.6-10 15.4-13.7 21.1-30.4 46.8-61 93.5-91.1 140.5-3.8 6-8.7 15-6.8 20.3 5.7 15.3 14.6 29.3 24 47.1 5.7-8.8 9.4-14.5 13.1-20.1 37.3-57.3 76-113.8 111.2-172.3 15.6-25.9 32.4-38.8 63-32.1 7.2 1.6 18.6-1.3 23.4-6.5 10.1-11 17-24.8 25.2-37.4-2.5-2.1-3.5-3.4-4.6-3.5m-270 140.2c-1.1 16.7-15.1 30-32.1 30-17.8 0-32.2-14.5-32.2-32.2 0-15.8 11.5-29 26.6-31.7 1.8-.3 3.7-.5 5.6-.5 17.8 0 32.2 14.5 32.2 32.2-.1.7-.1 1.5-.1 2.2"
              ></path>
              <path id="path9-9" d="M681.5 173.5"></path>
              <path
                id="path10-4"
                d="M806.4 291.6c-15.7-29.3-32.1-58.3-48.7-87.2 5.7-8.5 9.1-18.7 9.1-29.7 0-29.3-23.8-53.1-53.1-53.1s-53.1 23.8-53.1 53.1c0 28.7 23 52.2 51.5 53.1 11.8 21 23.3 41.4 34.5 61.9 3.1 5.6 6.6 14.2 4.4 18.9-7.1 15.4-16.8 29.6-27.4 47.4-5.6-10-9-16-12.4-21.9-27.4-48.6-54.6-97.3-82.4-145.8-3.5-6.2-9.3-14.7-14.8-15.4-16.2-2-32.8-.6-52.9-.5 5.2 9.2 8.5 15 11.8 20.9 33.6 59.6 65.7 120 101.3 178.3 15.7 25.8 19.4 46.7-.7 70.7-4.7 5.7-7.5 17.1-5.1 23.7 5.1 14 14.1 26.6 21.5 39.7 2.9-1.4 4.6-1.7 5.1-2.7 37.8-63.5 75.7-126.9 112.7-190.8 3.1-4.9 1.8-14.9-1.3-20.6M744.9 183c-3.6 13.8-16.2 24-31.2 24-5.6 0-11-1.5-15.6-4-9.9-5.5-16.6-16.1-16.6-28.2v-1.2c.7-17.2 14.9-31 32.2-31 17.8 0 32.2 14.5 32.2 32.2.1 2.8-.3 5.5-1 8.2"
              ></path>
            </g>
          </g>
        </g>
        <g id="g15" clipPath="url(#clipPath16)" transform="translate(1.651 .394)">
          <motion.circle
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ ...springTransition, delay: 0.6 }}
            id="path12-5-1"
            cx="358.437"
            cy="382.363"
            r="86.348"
            fill={fillColor}
            strokeWidth="0.269"
          ></motion.circle>
          <motion.circle
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ ...springTransition, delay: 0.8 }}
            id="path12-5-1-8"
            cx="357.254"
            cy="381.884"
            r="57.565"
            fill="hsl(73, 100%, 45%)"
            fillOpacity="1"
            strokeWidth="0.179"
          ></motion.circle>
          <motion.circle
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ ...springTransition, delay: 1 }}
            id="path12-5-1-8-6"
            cx="357.185"
            cy="381.321"
            r="28.783"
            fill={fillColor}
            strokeWidth="0.09"
            transform="translate(1.651 .394)"
          ></motion.circle>
        </g>
      </g>
    </svg>
  );
};
